import React from 'react';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '../../../../form/button/button';
import { Stack } from '../../../../stack/stack';
import { Loading } from '../../../../loading/loading';
import { useRootStore } from '../../../../../../providers/root-store-provider';

type OffBoardingStep3ActionProps = {
    onContinue: () => void;
    onCancel: () => void;
};

export const OffBoardingStep3Action: React.FC<OffBoardingStep3ActionProps> = observer(
    ({ onContinue, onCancel }: OffBoardingStep3ActionProps) => {
        const { t } = useTranslation();
        const { offboardingStore } = useRootStore();

        return (
            <Stack direction="vertical" alignItems="center" fullWidth>
                <Button
                    variant="positive"
                    block
                    variation="filled"
                    size="large"
                    onClick={onCancel}
                    loading={offboardingStore.loading}
                >
                    <Trans
                        i18nKey={'dialogs.offboarding.step3.button.cancel'}
                        components={{
                            badge: (
                                <span className="ml-xsmall inline-flex rounded-[10rem] bg-neutral-white/30 px-[1.4rem] py-[0.7rem] text-status-positive">
                                    0
                                </span>
                            ),
                        }}
                    />
                </Button>
                <Loading />
                <Button loading={offboardingStore.cancelLoading} variant={'white'} onClick={onContinue}>
                    {t('dialogs.offboarding.step4.button.continue')}
                </Button>
            </Stack>
        );
    },
);
